<template>
  <div class="acsidebar shadow-lg" v-show="sidebarloaded===true">
    <div class="text-center sidebarpl" v-show="sidebarenabled===false">
      <p><button @click="doUnCollapse" class="btn-transparent"><font-awesome-icon icon="bars" aria-label="Expand Sidebar"></font-awesome-icon></button></p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p><router-link :to="{name: 'pooldash', params: { id: pool.LicensePoolID }}"><font-awesome-icon icon="columns" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'poolmembers', params: { id: pool.LicensePoolID }}"><font-awesome-icon icon="user-friends" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'poolgroups', params: { id: pool.LicensePoolID }}"><font-awesome-icon icon="users" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'poolproducts', params: { id: pool.LicensePoolID }}"><font-awesome-icon icon="comment" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'poolbundles', params: { id: pool.LicensePoolID }}" name="bundles_m" style="display:none"><font-awesome-icon icon="comments" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'poolcurricula', params: { id: pool.LicensePoolID }}" name="training_plans_m" style="display:none"><font-awesome-icon icon="project-diagram" role="presentation"></font-awesome-icon></router-link></p>
      <p v-show="acctStatus==='Pool Administrator'"><router-link :to="{name: 'poolprivileges', params: { id: pool.LicensePoolID }}"><font-awesome-icon icon="user-lock" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'poolreporting', params: { id: pool.LicensePoolID }}"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'pooledit', params: { id: pool.LicensePoolID }}" name="edit_menu_m" style="display:none"><font-awesome-icon icon="edit" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'poollogs', params: { id: pool.LicensePoolID }}" name="logs_m" style="display:none"><font-awesome-icon icon="clipboard-list" role="presentation"></font-awesome-icon></router-link></p>
    </div>
    <div v-show="sidebarenabled===true" class="sidebarpl">
      <button @click="doCollapse" class="btn-transparent" style="margin-left:-15%;"><font-awesome-icon icon="bars" aria-label="Collapse Sidebar"></font-awesome-icon></button>
      <h3>{{pool.LicensePoolName}}</h3>
      <div class="accountstatus" id="account_status">{{acctStatus}}</div>
      <div class="sidebarlinks" v-if="pool!==null">
        <p><router-link :to="{name: 'pooldash', params: { id: pool.LicensePoolID }}" name="dashboard"><font-awesome-icon icon="columns" role="presentation"></font-awesome-icon> Dashboard</router-link></p>
        <p><router-link :to="{name: 'poolmembers', params: { id: pool.LicensePoolID }}" name="members"><font-awesome-icon icon="user-friends" role="presentation"></font-awesome-icon> Members</router-link></p>
        <p><router-link :to="{name: 'poolgroups', params: { id: pool.LicensePoolID }}" name="groups"><font-awesome-icon icon="users" role="presentation"></font-awesome-icon> Groups</router-link></p>
        <p><router-link :to="{name: 'poolproducts', params: { id: pool.LicensePoolID }}" name="products"><font-awesome-icon icon="comment" role="presentation"></font-awesome-icon> Products</router-link></p>
        <p><router-link :to="{name: 'poolbundles', params: { id: pool.LicensePoolID }}" name="bundles" style="display:none"><font-awesome-icon icon="comments" role="presentation"></font-awesome-icon> Bundles</router-link></p>
        <p><router-link :to="{name: 'poolcurricula', params: { id: pool.LicensePoolID }}" name="training_plans" style="display:none"><font-awesome-icon icon="project-diagram" role="presentation"></font-awesome-icon> Training Plans</router-link></p>
        <p v-show="acctStatus==='Pool Administrator'"><router-link :to="{name: 'poolprivileges', params: { id: pool.LicensePoolID }}" name="priviledges"><font-awesome-icon icon="user-lock" role="presentation"></font-awesome-icon> Privileges</router-link></p>
        <p><router-link :to="{name: 'poolreporting', params: { id: pool.LicensePoolID }}" name="reports_analytics"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon> Reports/Analytics</router-link></p>
        <p><router-link :to="{name: 'pooledit', params: { id: pool.LicensePoolID }}" name="edit_menu" style="display:none"><font-awesome-icon icon="edit" role="presentation"></font-awesome-icon> Edit</router-link></p>
        <p><router-link :to="{name: 'poollogs', params: { id: pool.LicensePoolID }}" name="logs" style="display:none"><font-awesome-icon icon="clipboard-list" role="presentation"></font-awesome-icon> Logs</router-link></p>
      </div>
      <div class="mt-5" v-if="showOrg===true">
        <button class="btn btn-secondary btn-gotoorg" @click="goToOrg" id="go_to_org">Go to Org</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .accountstatus {
    margin-top: 5%;
  }

  .btn-gotoorg {
    width: 125px !important;
  }

  .disableAnchor {
    color: darkgray !important;
    text-decoration: none !important;
  }
</style>

<script>
  export default {
    name: 'PoolSidebar',
    data() {
      return {
        acctStatus: "Data Viewer",
        pool: {
          LicensePoolName: "Loading",
          LicensePoolID: this.emptyguid
        },
        showOrg: null,
        sidebarenabled: null,
        sidebarloaded: false
      }
    },
    methods: {
      doCollapse() {
        this.sidebarenabled = false;
        this.collapseSidebar();
      },
      doUnCollapse() {
        this.sidebarenabled = true;
        this.deCollapseSidebar();
      },
      goToOrg() {
        this.$router.push({ name: 'orgpools', params: { id: this.pool.OrganizationID } });
      },
      showElements(elementNames) {
        elementNames.forEach(name => {
          const element = document.getElementsByName(name)[0];
          if (element) element.style.display = 'block';
        });
      }
    },
    mounted() {

      this.$bus.$on("PoolSidebarUpdateEvent", (poolstat, ap, showorg, isenabled) => {
        if (poolstat) {
          this.acctStatus = "Pool Administrator";
        }
        this.showOrg = showorg;
        this.pool = ap;

        if (typeof (isenabled) !== "undefined" && isenabled === false) {
          this.sidebarenabled = false;
          var self = this;
          window.setTimeout(function () {
            self.collapseSidebar();
            self.sidebarloaded = true;
          }, 100);
        }
        else {
          this.sidebarloaded = true;
          this.sidebarenabled = true;
        }
      });

      debugger;
      window.setTimeout(() => {
        //Below code hides the "Edit" and "Log" menu if user is lifeline
        var udata = JSON.parse(localStorage.getItem("udata"));

        this.apiCommand([{
          Operation: "LicensePool",
          Function: "isLifelineUser",
          Fields: {
            ClientID: udata.ClientID
          }
        }]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          let flag = JSON.parse(cr.returnObjects[0].returnObject);
          if (flag == "false") {

            // Define the elements to show
            const elementsToShow = [
              "edit_menu", "edit_menu_m", "logs", "logs_m",
              "bundles", "bundles_m", "training_plans", "training_plans_m"
            ];

            this.showElements(elementsToShow);
          }
        });
      }, 1000);

      setTimeout("Window.loadLanguageContent()", 500);
    },
    computed: {
      isDisabled() {
        if (sessionStorage.getItem("isSimmersionUser")) {
          return true;
        }
        else {
          return false;
        }
      }
    }
  }
</script>
